"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRegisteredDragSource = useRegisteredDragSource;

var _indexJs = require("../../internals/index.js");

var _useIsomorphicLayoutEffectJs = require("../useIsomorphicLayoutEffect.js");

var _useDragSourceJs = require("./useDragSource.js");

var _useDragDropManagerJs = require("../useDragDropManager.js");

var _useDragTypeJs = require("./useDragType.js");

function useRegisteredDragSource(spec, monitor, connector) {
  var manager = (0, _useDragDropManagerJs).useDragDropManager();
  var handler = (0, _useDragSourceJs).useDragSource(spec, monitor, connector);
  var itemType = (0, _useDragTypeJs).useDragType(spec);
  (0, _useIsomorphicLayoutEffectJs).useIsomorphicLayoutEffect(function registerDragSource() {
    if (itemType != null) {
      var _registerSource = (0, _indexJs).registerSource(itemType, handler, manager),
          _registerSource2 = _slicedToArray(_registerSource, 2),
          handlerId = _registerSource2[0],
          unregister = _registerSource2[1];

      monitor.receiveHandlerId(handlerId);
      connector.receiveHandlerId(handlerId);
      return unregister;
    }

    return;
  }, [manager, monitor, connector, handler, itemType]);
}